const WPAPI = require("wpapi");
const settings = require("./settings");

let wp = new WPAPI({
    endpoint: `${process.env.WORDPRESS_URL}/wp-json`
});

// Whitelist specific field needed for Resource listings
const RESOURCE_LISTING_FIELDS = [
    "slug",
    "title",
    "excerpt",
    "type",
    "type_pretty",
    "thumbnail",
    "acf",
    "date",
    "categories", // Blog posts
    "customer_logo", // Case studies
    "read_time",
    "external_url" // News
];

const AUTHOR_FIELDS = [
    "_links",
    "acf",
    "slug",
    "id",
    "avatar_urls",
    "name",
    "description"
];

/**
 * Register custom API endpoints on for the client side.
 */

// Get Page or Post by its full path
wp.pageOrPostPath = wp.registerRoute(
    "fathom/v1",
    "/path/(?P<path>.*?)?_embed=1"
);

// Wordpress Frontpage object
wp.frontpage = wp.registerRoute("fathom/v1", "/frontpage");

// Authors
wp.author = wp.registerRoute("fathom/v1", "/author/(?P<slug>S+)");
wp.authors = wp.registerRoute("fathom/v1", "/authors");

// Global site data (menus, featured content, etc)
wp.global = wp.registerRoute("fathom/v1", "/global-data");

// Resource types
wp.casestudies = wp.registerRoute("wp/v2", "/case-studies/(?P<slug>S+)");
wp.glossary = wp.registerRoute("wp/v2", "/inside-sales-glossary/(?P<slug>S+)");
wp.infographics = wp.registerRoute("wp/v2", "/infographics/(?P<slug>S+)");
wp.landingpages = wp.registerRoute("wp/v2", "/lp/(?P<slug>S+)");
wp.embeddedpage = wp.registerRoute("wp/v2", "/embed/(?P<slug>S+)");
wp.news = wp.registerRoute("wp/v2", "/news/(?P<slug>S+)");
wp.thankyou = wp.registerRoute("wp/v2", "/thank-you/(?P<slug>S+)");
wp.tools = wp.registerRoute("wp/v2", "/tools/(?P<slug>S+)");
wp.webinars = wp.registerRoute("wp/v2", "/webinars/(?P<slug>S+)");
wp.whitepapers = wp.registerRoute("wp/v2", "/ebooks/(?P<slug>S+)");
wp.podcasts = wp.registerRoute("wp/v2", "/podcasts/(?P<slug>S+)");
wp.videos = wp.registerRoute("wp/v2", "/revu/(?P<slug>S+)");
wp.testimonials = wp.registerRoute("wp/v2", "/testimonials/(?P<slug>S+)");
wp.revenueexchange = wp.registerRoute("wp/v2", "/revenue-exchange/(?P<slug>S+)");
//wp.posts = wp.registerRoute("wp/v2", "/posts/(?P<slug>S+)");
//wp.events = wp.registerRoute("wp/v2", "/events/(?P<slug>S+)");


// Resource topics
wp.topics = wp.registerRoute("wp/v2", "/resource-topics");
wp.products = wp.registerRoute("wp/v2", "/product-categories");
wp.demotypes = wp.registerRoute("wp/v2", "/demo-types");
wp.revutopics = wp.registerRoute("wp/v2", "/revu-topics");

// Custom resource queries
wp.superquery = wp.registerRoute("wp_query", "/args", {
    params: [
        "post_type",
        "type_pretty",
        "author",
        "posts_per_page",
        "paged",
        "s"
    ]
});

// Yoast redirects
wp.redirects = wp.registerRoute("wp-rest-yoast-meta/v1", "/redirects");

const getClient = () => {
    return wp;
};

const getResourceQuery = ({ type, page }) => {
    let postperPage = settings.api.perPageDefault;
    let glossaryFields = null;
    if (!Object.prototype.hasOwnProperty.call(wp, type)) {
        console.error(`WP Client has not route registered for type "${type}"`);
        return () => Promise.resolve();
    }
    if (type === "glossary") {
      postperPage = 300;
      page = 1;
      glossaryFields = "glossary-term, slug, type";
    }

    return () =>
        wp[type]()
            .page(page)
            .perPage(postperPage)
            .param("_fields", glossaryFields);
};

const getResourceDetailQuery = ({ type, slug }) => {
    if (!Object.prototype.hasOwnProperty.call(wp, type)) {
        console.error(`WP Client has not route registered for type "${type}"`);
        return () => Promise.resolve();
    }

    return () =>
        wp[type]()
            .slug(slug)
            .embed();
};


/**
 * Paged query to get all content types that should appear in the resources main listing
 */
const getResourcesListing = ({ page }) => {
    return () =>
        wp
            .superquery()
            .post_type([
//              "casestudies",
                "infographics",
//              "webinars",
                "whitepapers",
                "tools",
//              "podcasts",
//              "revenueexchange",
//              "glossary",
//              "post"
            ])
            .posts_per_page(settings.api.perPageDefault)
            .paged(page)
            .param("_fields", RESOURCE_LISTING_FIELDS);
};

const getTaxIdFromSlug = ({ tax, slug }) => {
    return () =>
        wp[tax]()
            .slug(slug)
            .param("_fields", ["id", "slug"]);
};

const getAuthorBySlug = slug => {
    return () =>
        wp
            .users()
            .slug(slug)
            .param("_fields", AUTHOR_FIELDS)
            .embed();
};

const getFilteredResources = () => {
    return () =>
        wp
            .superquery()
            .posts_per_page(100)
            .param("_fields", RESOURCE_LISTING_FIELDS);
};

module.exports = {
    getClient,
    getResourceQuery,
    getResourceDetailQuery,
    getResourcesListing,
    getTaxIdFromSlug,
    getAuthorBySlug,
    getFilteredResources
};
